import script from "./FacturaTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FacturaTable.vue?vue&type=script&setup=true&lang=js"

import "./FacturaTable.vue?vue&type=style&index=0&id=4aeb7935&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aeb7935"]])

export default __exports__